<template lang="pug">
div
  slot(name="reasontype", :reason="reason")
    p.radio-group 推荐关键词筛选：
      v-radio-group(
          v-model = "reason.currentReason",
          :name = "'reason'",
          :options = "reason.reasonList"
        )
    span.floatr.advice-tip 采纳以下
      i.red  {{adviceSuggestNum}} 
      | 个建议预计展现量提升 
      i.red {{adviceEstiAddAdpv}} 
      //| 预计点击量提升
      //i.red {{adviceEstiAddAdclick}}

  .advice-table
    HeadFixedTable(
        :columns = "currentColumns",
        :checkbox="hasCheckbox",
        :check_all="hasCheckbox",
        :checkbox_length="1000",
        :isAllChecked= "isAllChecked",
        :list = "currentList",
        :hasPagination = "true",
        @pageChange = "pageChange"
      )
      v-tooltip(
        slot="bidtype",
        :tip="'为您推荐同类账户中该关键词设置的匹配模式'",
        pos="left")
        i.fa.fa-question-circle(style="margin-left: 5px;")
      v-tooltip(
        slot="rec_price",
        :tip="'结合出价目标和同类客户对该词的出价意愿为您推荐出价建议，出价不得低于0.3元'",
        pos="left")
        i.fa.fa-question-circle(style="margin-left: 5px;")
      template(slot="planId-td" scope="props")
        span(v-show="!props.item.planEdit")
          span(:title="props.item.submit_plan") {{props.item.submit_plan | planGroupName}} 
          span -
          span(:title="props.item.submit_plan")  {{props.item.submit_groupName | planGroupName}}
        span(@click.stop="stop")
          Casecade(
            ref="plangroup",
            v-if="props.item.planEdit",
            :selected="props.item.submit_planId + ''",
            :subSelected="props.item.submit_groupId + ''",
            :options="planList",
            :subOptions="groupList",
            @search="getSearchPlanList",
            @subsearch="subSearch",
            @change="savePlanGroup"
            )
        span.btn.btn-icon(@click.stop="openPlanGroup(props.item)" v-show="isItemEditable(props.item)")
          i.fa.fa-edit

      template(slot="bidtype-td" scope="props")
        span(v-show="!props.item.bidtypeEdit") {{props.item | bidtypeFilter}}
        span(@click.stop="stop")
          v-select(v-model="props.item.submit_bidtype",
            ref="bidtype",
            v-show="props.item.bidtypeEdit",
            @input="saveBidtype(props.item)",
            :options="bidtypes"
            )
        span.btn.btn-icon(@click.stop="openBidtype(props.item)" v-show="isItemEditable(props.item)")
          i.fa.fa-edit
      template(slot="rec_price-td" scope="props")
        span(v-show="!props.item.priceEdit") {{props.item.submit_price}}
        span(@click.stop="stop",
          v-if="props.item.priceEdit",
          style="position: relative"
          )
          input.size-small(type="text",
            ref="price",
            :placeholder="'最多保留两位小数'",
            :class="{'error': isPriceUnvalid(props.item)}",
            v-model="props.item.submit_price",
            @keyup.enter="saveprice(props.item)",
          )
          span.warning-tip(v-show="props.item.lowpriceshow && advicePriceWarning != ''")
            | {{advicePriceWarning}}
            i.fa.fa-times(@click.stop="props.item.lowpriceshow = false")
        span.btn.btn-icon(@click.stop="openPriceEdit(props.item)" v-show="isItemEditable(props.item)")
          i.fa.fa-edit
      template(slot="delete-td" scope="props")
          slot(name="delete", :item="props.item")
      template(slot="status-td" scope="props")
          slot(name="status", :item="props.item")

</template>

<script>
import HeadFixedTable from '../../component/fold-table.vue'
import Casecade from '../../component/casecade.vue'
import SearchSelect from '../../component/search-select.vue'
import { BIDTYPE } from './constants.js'
import Calendar from 'v-tags/components/calendar/index.vue'
import Mixin from '../mixin.js'

export default {
  mixins: [Mixin],
  props: {
    extendColumns: {
      type: Array,
      default() {
        return  []
      }
    },
    hasCheckbox: {
      type: Boolean,
      default: true
    },
    isAllChecked: {
      type: Boolean,
      default: false
    },
    isEditable: {
      type: Boolean,
      default: true
    },
    list: {
      type: [Array, Object],
      default() {
        return [{
          "keyword": "关键词",
          "kr": "关键词",
          "plan": "测试",
          "planId": 111,
          "group": "测试组",
          "groupId": 111,
          "price": 0.5,
          "lowprice": 0.4,
          "bidtype": 1,
          "adpv": 100,
          "adclick": 10,
          "adcost": 10,
          "adcpc": 10,
          "adcpm": 10,
          "anum": 10,
          "reason": 'qz',
          "reasonDesc": "抢占",
          planEdit: false,
          matchtypeEdit: false,
          priceEdit: false,
          lowpriceshow: false
        },{
          "keyword": "关键词",
          "kr": "关键词",
          "plan": "测试",
          "planId": 111,
          "group": "测试组",
          "groupId": 111,
          "price": 0.5,
          "lowprice": 0.3,
          "matchtype": 1,
          "bidtype": 1,
          "adpv": 100,
          "adclick": 10,
          "adcost": 10,
          "adcpc": 10,
          "adcpm": 10,
          "anum": 10,
          "reason": 'hot',
          "reasonDesc": "hot",
          planEdit: false,
          matchtypeEdit: false,
          priceEdit: false,
          lowpriceshow: false
        },{
          "keyword": "关键词",
          "kr": "关键词",
          "plan": "测试",
          "planId": 111,
          "group": "测试组",
          "groupId": 111,
          "bidtype": 3,
          "price": 0.5,
          "lowprice": 0.3,
          "matchtype": 1,
          "adpv": 100,
          "adclick": 10,
          "adcost": 10,
          "adcpc": 10,
          "adcpm": 10,
          "anum": 10,
          "reason": 'new',
          "reasonDesc": "new",
          planEdit: false,
          matchtypeEdit: false,
          priceEdit: false,
          lowpriceshow: false
        },{
          "keyword": "关键词",
          "plan": "测试",
          "planId": 111,
          "bidtype": 2,
          "group": "测试组",
          "groupId": 111,
          "price": 0.5,
          "lowprice": 0.3,
          "matchtype": 1,
          "adpv": 100,
          "adclick": 10,
          "adcost": 10,
          "adcpc": 10,
          "adcpm": 10,
          "anum": 10,
          "reason": 'qz',
          "reasonDesc": "抢占",
          planEdit: false,
          matchtypeEdit: false,
          priceEdit: false,
          lowpriceshow: false
        }]
      }
    } 
  },
  components: {
      HeadFixedTable,
      'search-select': SearchSelect,
      Casecade
  },
  data() {
    return {
      isAllAdviceChecked : false,
      advicePriceWarning : "",
      allPlanList: [],
      planList: [],
      groupList: [],
      bidtypes: BIDTYPE,
      reason: {
        currentReason: 'all',
        reasonList: []
      },
      currentReason: "all",
      currentEditItem: {},
      dianjingLowPrice: 0.3,
      priceEditable: true
    }
  },
  filters: {
    bidtypeFilter(item) {
      return _.find(BIDTYPE, {value: +item.submit_bidtype}) ? _.find(BIDTYPE, {value: +item.submit_bidtype }).label : ''
    },
    planGroupName(item) {
      return item.slice(0, 15)
    }
  },
  watch: {
      domainId() {
        this.getAllPlanList()
      },    
      adviceGroupObj() {
        this.updateReasonList()
      },
      list() {
        this.getAllPlanList()
      }
  },
  computed: {
    //勾选建议数量
    adviceSuggestNum() {
      return this.$store.state.tableCheckList.length
    },
    adviceEstiAddAdclick() {
      let result = 0
      _.map(this.$store.state.tableCheckList, (item) => {
        result += +item.esti_add_adclick
      })
      return result
    },
    adviceEstiAddAdpv() {
      let result = 0
      _.map(this.$store.state.tableCheckList, (item) => {
        result += +item.esti_add_adpv
      })
      return result
    },
    djid() {
      return this.$store.state.dianjingID
    },
    currentPageDataList() {
      return this.$store.state.tableCheckList
    },
    domainId() {
      return this.$store.state.domainId
    },
    currentColumns() {
      let emptyRender = (index, value, item) => {
                return "" 
              }
      let columnslist =  [{
            title: "推荐关键词",
            key: "bidword",
            style: "width: 220px;",
            render: (index, value, item) => {
              return `<span title="${value}">${value}</span>`
            }
          },{
            title: "推荐理由",
            key: "reasonDesc"
          },{
            title: "推广计划-推广组",
            key: "planId",
            style: "width: 300px;",
            render: emptyRender
          },{
            title: "匹配模式",
            key: "bidtype",
            render: emptyRender
          },{
            title: "建议出价(￥)",
            key: "rec_price",
            class: "right",
            render: emptyRender
          },{
            title: "出价目标",
            key: "pos",
            class: "right",
            render: (index, value, item) => {
              const pos = {
                0: "其他",
                1: "左侧前三",
                2: "右侧",
                3: "左侧"
              }
              return pos[value]
            }
          }]
        return _.concat(columnslist, this.extendColumns)
    },
    adviceGroupObj() {
      let list = _.map(_.cloneDeep(this.list), item => {
        this.$set(item, 'checked', false)
        this.$set(item, 'priceEdit', false)
        this.$set(item, 'bidtypeEdit', false)
        this.$set(item, 'planEdit', false)
        this.$set(item, 'lowpriceshow', false)
        !_.has(item, 'submit_price') && this.$set(item, 'submit_price', parseFloat(item.rec_price, 10).toFixed(2))
        !_.has(item, 'submit_plan') && this.$set(item, 'submit_plan', item.plan + '')
        !_.has(item, 'submit_groupName') && this.$set(item, 'submit_groupName', item.groupName + '')
        !_.has(item, 'submit_bidtype') && this.$set(item, 'submit_bidtype', +item.bidtype)
        !_.has(item, 'submit_planId') && this.$set(item, 'submit_planId', item.planId)
        !_.has(item, 'submit_groupId') && this.$set(item, 'submit_groupId', item.groupId)
        return item
      })
      return _.extend({
          all: list
        }, _.groupBy(list, 'reason'))
    },
    currentList() {
      return this.adviceGroupObj[this.reason.currentReason]
    }
  },
  mounted() {
    if(this.hasCheckbox){
      this.updateReasonList()
    }
    if(!_.isEmpty(this.list)){
      this.getAllPlanList()
    }
    document.addEventListener('click', this.closeEditPanel);
  },
  destroyed() {
    document.removeEventListener('click', this.closeEditPanel);
  },
  methods: {
    stop() {},
    isPriceUnvalid(item) {
      if(!/^\d+(\.\d{0,2})?$/.test(item.submit_price)) {
        this.advicePriceWarning = `请输入有效数字，最多保留两位小数`
        return true
      } else if(parseFloat(item.submit_price, 10) < this.dianjingLowPrice) {
        this.advicePriceWarning = `结合出价目标和同类客户对该词的出价意愿为您推荐出价建议,出价不得低于${this.dianjingLowPrice}元`
        return true
      } else {
        return false
      }
    },
    pageChange(list) {
      this.$emit('pageChange', list)
    },
    isItemEditable(item) {
      return this.isEditable && !item.status
    },
    openPriceEdit(item) {
      this.closeEditPanel(item)
      if(!item.priceEdit && this.priceEditable){
        this.priceEditable = false
        this.$set(item, 'priceEdit', true)
      }
    },
    openBidtype(item) {
      this.closeEditPanel(item)
      if(!item.bidtypeEdit && this.priceEditable) { 
        this.$set(item, 'bidtypeEdit', true)
      }
    },
    openPlanGroup(item) {
      this.closeEditPanel(item)
      if(!item.planEdit && this.priceEditable) {
        this.planList = _.cloneDeep(this.allPlanList)
        this.getGroupList(item.submit_planId)

        this.currentEditItem = item
        this.$set(item, 'planEdit', true)
      }
    },
    closeEditPanel(item) {
      let editPriceObj = _.find(this.currentPageDataList, item => item.priceEdit)
      let editPlanObj = _.find(this.currentPageDataList, item => item.planEdit)
      let editBidTypeObj = _.find(this.currentPageDataList, item => item.bidtypeEdit)
      !_.isEmpty(editPriceObj) && this.saveprice(editPriceObj)
      !_.isEmpty(editPlanObj) && this.savePlanGroup(editPlanObj)
      !_.isEmpty(editBidTypeObj) && this.saveBidtype(editBidTypeObj)
      if( _.isEmpty(editPriceObj) && _.isEmpty(editPlanObj) && _.isEmpty(editBidTypeObj) && _.has(item, 'id')) {
        this.pushItemIntoCheckList(item)
      } 
    },
    saveBidtype(item) {
      this.$set(item, 'bidtypeEdit', false)
    },
    savePlanGroup(planGroupObj) {
      this.planList = _.cloneDeep(this.allPlanList)
      if(!_.isEmpty(this.planList) && planGroupObj.currentSelected && planGroupObj.currentSubSelected){
        this.$set(this.currentEditItem, 'submit_planId', planGroupObj.currentSelected)
        this.$set(this.currentEditItem, 'submit_groupId', planGroupObj.currentSubSelected)

        this.$set(this.currentEditItem, 'submit_plan',_.find(this.planList, {value: this.currentEditItem.submit_planId}).label)
        this.currentEditItem.submit_groupId != '' && this.$set(this.currentEditItem, 'submit_groupName',_.find(this.groupList, {value: this.currentEditItem.submit_groupId}).label)
      }
      this.$set(this.currentEditItem, 'planEdit', false)
    },
    updateReasonList() {
      let list = _.reduce(this.adviceGroupObj, (result, value, key) => {
        result.push({
          value: key,
          title: key == 'all' ? '全部关键词' : value[0].reasonDesc
        })
        return result
      }, [])
      this.$set(this.reason, 'reasonList', list)
    },
    saveprice(item) {
      if(this.isPriceUnvalid(item)){
        item.lowpriceshow = true
        return
      } else {
        item.lowpriceshow = false
      }
      if(item.submit_price < item.low_price) {
        this.advicePriceWarning = `出价低于${item.low_price}将达不到优化效果`
        item.lowpriceshow = true
        setTimeout(() => {
          item.lowpriceshow = false
        }, 3000)
      }
      this.$set(item, 'submit_price', parseFloat(item.submit_price, 10).toFixed(2))
      this.priceEditable = true
      item.priceEdit = false
    },
    subSearch(planid, value) {
      this.getGroupList(planid, value)
    },
    getAllPlanList() {
      this.getPlanList()
        .then((res) => {
          if(res) {
            this.allPlanList = _.map(res.list, item => {
              return {
                value: item.id,
                label: item.name
              }
            })
          }
        })
    },
    getSearchPlanList(name) {
      if(name.trim() == '') {
        this.planList = _.cloneDeep(this.allPlanList)
        return
      }
      this.getPlanList(name)
        .then((res) => {
          if(res) {
              this.planList = _.map(res.list, item => {
                return {
                  value: item.id,
                  label: item.name
                }
              })
            }
        })
    },
    getPlanList(name="") {
      let params = {
            djid: this.djid,
            domainId: this.domainId,
            planName: name,
            timespan: new Date().getTime()
        }

      let planPromise = this.$http.get('/api/aoComm/planList', {params: params})
      return this.$store.dispatch("VUE_HTTP", [planPromise])
    },
    getGroupList(planId, name) {
      let params = {
          djid: this.djid,
          domainId: this.domainId,
          groupName: name,
          planId: planId,
          timespan: new Date().getTime()
      }
      let groupPromise = this.$http.get('/api/aoComm/groupList', {params: params})

      this.$store.dispatch("VUE_HTTP", [groupPromise])
        .then((res) => {
          if(res) {
            this.groupList = _.map(res.list, item => {
              return {
                value: item.id,
                label: item.name
              }
            })
          }
        })
    }
  }
}
</script>
<style scoped>
.fold-table .btn-icon{
  padding: 0 5px;
  vertical-align: baseline;
}
.advice-tip {
  margin-right: 20px;
  margin-top: 20px;
  margin-bottom: 20px;
  line-height: 1em;
}
.modal-bd-wrapper .modal-table-wrapper .advice-table{
    border: 1px solid #DADFE6;
    border-top: none;
}
</style>



// WEBPACK FOOTER //
// kr_advice_table.vue?06002b71